/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-16 11:27:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/PrimaryActionButtonStyle/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getPrimaryActionButtonStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onPrimaryActionButtonStyleChange,
  onPrimaryActionButtonStyleReset,
} from '../slice';

const idSet = {
  backgroundColour: suffix + 'backgroundColour',
  textColour: suffix + 'textColour',
};
const PrimaryActionButtonStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { backgroundColor, textColor } = data || {};

  const _d = useDispatch();

  const handleOnBkgChange = (backgroundColor) => {
    _d(onPrimaryActionButtonStyleChange({ backgroundColor }));
  };

  const handleOnTextChange = (textColor) => {
    _d(onPrimaryActionButtonStyleChange({ textColor }));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          id={idSet.backgroundColour}
          title={getI18n('general.backgroundColour')}>
          <ColorPicker
            id={idSet.backgroundColour}
            onChange={handleOnBkgChange}
            multi
            color={backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.textColour}
          title={getI18n('general.textColour')}>
          <ColorPicker
            onChange={handleOnTextChange}
            multi
            id={idSet.textColour}
            color={textColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(PrimaryActionButtonStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.primaryCallToActionButtonStyle,
  getContent: getPrimaryActionButtonStyle,
  title: getI18nFromGeneral('general.hOCTitle.primaryCallToActionButtonStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onPrimaryActionButtonStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
